export default __webpack_public_path__ + "0ac3aaa9174e11fea2ecb194c00aceff.png";